import { motion, useReducedMotion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { HeroQuotes } from "@/components/site/HeroQuotes";

const ease = [0.22, 1, 0.36, 1];

const Line = ({ children, delay, className }) => {
  const reduce = useReducedMotion();
  return (
    <span className="mask-line">
      <motion.span
        className={className}
        initial={reduce ? false : { y: "110%" }}
        animate={{ y: "0%" }}
        transition={{ duration: 1, delay, ease }}
      >
        {children}
      </motion.span>
    </span>
  );
};

const Fade = ({ children, delay, className, as = "div", ...rest }) => {
  const reduce = useReducedMotion();
  const Tag = motion[as];
  return (
    <Tag
      className={className}
      initial={reduce ? false : { opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay, ease }}
      {...rest}
    >
      {children}
    </Tag>
  );
};

const LightBeam = () => (
  <div className="hero-beam" aria-hidden="true" data-testid="hero-light">
    <span className="beam-cone" />
    <span className="beam-flare" />
    <span className="beam-sweep" />
  </div>
);

export const Hero = () => (
  <section id="home" className="hero" data-testid="hero-section">
    <LightBeam />
    <div className="hero-inner shell">
      <div className="hero-copy">
        <h1 className="hero-title" data-testid="hero-title">
          <Line delay={0.1} className="t-the">THE</Line>
          <Line delay={0.22} className="t-name">BLAKE SMITH</Line>
          <Line delay={0.34} className="t-company">COMPANY</Line>
        </h1>
        <motion.div
          className="gold-rule"
          initial={{ scaleX: 0 }}
          animate={{ scaleX: 1 }}
          transition={{ duration: 1.1, delay: 0.6, ease }}
        />
        <Fade delay={0.7} as="h2" className="hero-tagline">
          Creative Solutions. Digital Innovation.<br />Business Growth.
        </Fade>
        <Fade delay={0.8} as="p" className="hero-text">
          We help businesses grow through strategic marketing, effective advertising, professional
          website development, and custom mobile applications.
        </Fade>
        <Fade delay={0.9}>
          <a className="btn btn-gold" href="#contact" data-testid="hero-get-started-btn">
            Get Started <ArrowRight size={18} strokeWidth={2.4} aria-hidden="true" />
          </a>
        </Fade>
      </div>
      <HeroQuotes />
    </div>
    <div className="glow-line" aria-hidden="true" />
  </section>
);
